<template>
  <router-view />
</template>

<script>
/**
 * App.vue - 根组件
 * 功能：应用入口，挂载全局样式与路由视图
 * 主要依赖：vue-router
 */
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f7fa;
}
</style>
